/* loaded by smart-asset */
export default require("./menu-24px~paROkgOZ.svg")